import { render, staticRenderFns } from "./operadorLogistico.vue?vue&type=template&id=758f51f6"
import script from "./operadorLogistico.vue?vue&type=script&lang=js"
export * from "./operadorLogistico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports